import type { PhaseKey, DifficultyOption, DifficultyOptionDTO } from "@akina/domain";
import { difficultyOptionsMapper } from "../mappers";
import { type ApiConfiguration, ApiMethod } from "./shared";

export const difficultyOptionsApi = (config: ApiConfiguration) => ({
  async get(params: {
    routineTemplateKey: string | null;
    treatmentTemplateKey: string | null;
    phaseKey: PhaseKey | null;
  }): Promise<DifficultyOption> {
    await new Promise(resolve => setTimeout(resolve, 300));
    const result = await config.httpService.fetch<DifficultyOptionDTO>({
      method: ApiMethod.GET,
      url: config.endpoints.difficultyOptions.get(params),
    });

    return difficultyOptionsMapper.toDomain(result);
  },
});
